import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withStyles,
  WithStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React from "react";

type EditConciliationDateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
} & WithStyles<typeof styles>;

function EditConciliationDateModal({
  classes,
  isOpen,
  onClose,
  onConfirm,
}: EditConciliationDateModalProps) {
  const { t } = useTranslations();

  return (
    <Dialog
      className={classes.dialog}
      data-testid="edit-conciliation-date-modal"
      fullWidth={true}
      id="edit-conciliation-date-modal"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle className={classes.modalTitle} data-testid="dialog-title">
        {t("conciliation:edit-conciliation-date-modal.title")}
      </DialogTitle>

      <DialogContent data-testid="dialog-content">
        <DialogContentText>
          {t("conciliation:edit-conciliation-date-modal.content")}
        </DialogContentText>
      </DialogContent>

      <DialogActions data-testid="dialog-actions">
        <Button color="primary" onClick={onClose} data-testid="cancel-button">
          {t("common:actions.cancel")}
        </Button>
        <Button
          autoFocus={true}
          color="primary"
          onClick={onConfirm}
          data-testid="confirm-button"
        >
          {t("common:actions.yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = () =>
  createStyles({
    dialog: {
      margin: "auto",
    },
    modalTitle: {
      fontWeight: "bold",
    },
  });

export default withStyles(styles)(EditConciliationDateModal);
